/* eslint-disable @typescript-eslint/no-use-before-define */
import { createAction } from '@reduxjs/toolkit'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { Style } from 'src/common/common.interface'
import { getAllStyles } from 'src/api/templateProduct'
import { styleAction } from './style.slice'

export function* getAllStylesSaga() {
  try {
    const res: Style[] = yield call(getAllStyles)
    yield put(styleAction.setStylesData(res))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error getAllStylesSaga', error)
  } finally {
    yield put(styleAction.setIsLoadingGetStyles(false))
  }
}

export const styleActionSaga = {
  getAllStyles: createAction('styleActionSaga/getAllStyles')
}

export default [
  function* fetchWatcher() {
    yield all([takeLatest(styleActionSaga.getAllStyles, getAllStylesSaga)])
  }
]
